/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { multiUploadTracksModelSchema } from "../multiUploadTracksModelSchema.ts";
import { multiUploadTracksRequestModelSchema } from "../multiUploadTracksRequestModelSchema.ts";
import { z } from "zod";

export const postApiTracksAlbumidMultiUploadPathParamsSchema = z.object({
    "AlbumId": z.string().uuid().describe("Идентификатор альбома")
    })

/**
 * @description Словарь треков
 */
export const postApiTracksAlbumidMultiUpload200Schema = z.lazy(() => multiUploadTracksModelSchema)

/**
 * @description В запросе указаны дублирующие значения ключа | Ошибка валидации
 */
export const postApiTracksAlbumidMultiUpload400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiTracksAlbumidMultiUpload401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiTracksAlbumidMultiUpload403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Альбом не найден
 */
export const postApiTracksAlbumidMultiUpload404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiTracksAlbumidMultiUpload500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiTracksAlbumidMultiUploadMutationRequestSchema = z.array(z.lazy(() => multiUploadTracksRequestModelSchema)).describe("Тело запроса")

export const postApiTracksAlbumidMultiUploadMutationResponseSchema = z.lazy(() => postApiTracksAlbumidMultiUpload200Schema)